// extracted by mini-css-extract-plugin
export default {"title":"FilterStudents_title__HGUAb","list":"FilterStudents_list__s-I55","list_item":"FilterStudents_list_item__1bSwx"};